import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminLeads() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/leads").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-heading text-3xl font-extrabold mb-8">Messages de contact</h1>
      <div className="space-y-4">
        {rows.map((l) => (
          <div key={l.id} className="bg-white border border-gray-200 p-6" data-testid={`lead-${l.id}`}>
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-semibold">{l.name}</h3>
                <p className="text-sm text-gray-500">{l.email} {l.phone && `· ${l.phone}`}</p>
              </div>
              <span className="text-xs text-gray-400">{new Date(l.created_at).toLocaleString("fr-CA")}</span>
            </div>
            <p className="text-gray-700 mt-4 text-sm leading-relaxed">{l.message}</p>
          </div>
        ))}
        {rows.length === 0 && <p className="text-gray-400 py-16 text-center">Aucun message.</p>}
      </div>
    </div>
  );
}
